/* eslint-disable indent */
/* eslint-disable quotes */
/* eslint-disable react/jsx-key */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Image } from "react-bootstrap";

import Papa from "papaparse";
// import moment from "moment";

// import { userActions } from "../../../redux/actions";
import Button from "../../../component/button/Button";
import SelectInput from "../../../component/input/SelectInput";
import Card from "../../../component/card/Card";
import ErrorRender from "../../../component/request/ErrorRender";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import P from "../../../component/smallComponents/P";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Strong from "../../../component/smallComponents/Strong";
import TextInput from "../../../component/input/TextInput";

import ResponseRender from "../../../component/request/ResponseRender";
import { authActions, ruleActions } from "../../../redux/actions";
import { Link } from "react-router-dom";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction,
  toastHelper
} from "../../../constant/helper/helper";
import register_user from "../../../images/register_user.jpeg";
import { helperFunction } from "../../../constant/helper";
import sampleExcelFile from "../../../images/cmc_sample_header_all_user.xlsx";
import Starter from "../../../component/Starter";
import { getAllZones } from "../../../redux/actions/hrActions";
import isEmpty from "../../../validation/isEmpty";
import WorkerTable from "./WorkerTable";

const ExcelRegister = () => {
  const loginType = localStorage.loginType;

  const dispatch = useDispatch();
  const [ruleId, setRuleId] = useState("");
  // const [columns, setColumns] = useState([]);
  const [response, setResponse] = useState("");
  const [isUpdate, setIsUpdate] = useState("");
  const [allRules, setAllRules] = useState([]);
  const [excelFile, setExcelFile] = useState(null);
  const [allLocations, setAllLocations] = useState([]);
  const [locationId, setSelectLocationId] = useState("");
  const [ExcelOrCsvData, setExcelOrCsvData] = useState([]);

  const [allZoneData, setAllZoneData] = useState([]);
  const [zoneId, setZoneId] = useState("");

  const { currentUser } = useSelector((state) => state.auth);
  const { rules } = useSelector((state) => state.rule);
  const { locations } = useSelector((state) => state.location);
  const { allZones } = useSelector((state) => state.hr);

  useEffect(() => {
    setAllLocations(locations);
  }, [locations]);

  useEffect(() => {
    if (!isEmpty(allZones)) {
      setAllZoneData(allZones);
    } else {
      setAllZoneData([]);
    }
  }, [allZones]);

  useEffect(() => {
    dispatch(getAllZones(loginType));
  }, []);

  const {
    authError,
    authLoading,
    authResponse,
    authRegisterUserError
  } = useSelector((state) => state.auth);

  useEffect(() => {
    if (authError) {
      helperFunction.toastHelper("error", authError);
    }
    if (authResponse) {
      setResponse(authResponse);
      helperFunction.toastHelper("success", authResponse);
    }
  }, [authError, authResponse]);

  const onSubmit = (e) => {
    e.preventDefault();
    const userCsvToJsonData = {
      ruleId,
      isUpdate,
      locationId,
      zoneId,
      ExcelOrCsvData
    };
    console.log(excelFile);
    // console.log(userCsvToJsonData);
    dispatch(authActions.setAuthLoading(true));
    dispatch(authActions.clearAuthErrors());
    dispatch(authActions.clearAuthResult());
    dispatch(authActions.registerExcel(userCsvToJsonData, loginType));
  };

  useEffect(() => {
    dispatch(authActions.setAuthLoading(false));
    dispatch(authActions.clearAuthErrors());
    dispatch(authActions.clearAuthResult());
    return () => {
      setExcelFile(null);
      dispatch(authActions.setAuthLoading(false));
      dispatch(authActions.clearAuthErrors());
      dispatch(authActions.clearAuthResult());
    };
  }, []);

  const isValidDateString = (dateString) => {
    return !isNaN(Date.parse(dateString));
  };

  const userCsvRequiredFiled = [
    "workerFirstName",
    "workerSurname",
    "workerDepartment",
    "workerDesignation",
    "workerAadharCardNumber",
    "workerPhoneNumber",
    "workerId",
    "workerType",
    "workerEmail",
    "workerStatus",
    "gender",
    "dateOfJoining"
  ];

  // handle file upload
  const convertingCsvIntoJson = (csvFile) => {
    const aadharRegex = /^[2-9]{1}[0-9]{11}$/;
    const phoneRegex = /^[0-9]{10}$/;

    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: "greedy", // safely ignore real empty lines
      dynamicTyping: false, // keep values as strings (preserve IDs/leading zeros)
      transformHeader: (h) => (h || "").trim(), // trim header keys
      transform: (v) => (v == null ? "" : String(v).trim()), // trim every cell value
      complete: ({ data, errors }) => {
        try {
          if (errors && errors.length) {
            console.warn("Papa parse warnings/errors:", errors);
          }

          // Filter out rows that are entirely empty after trimming
          const cleanedRows = data.filter((row) =>
            Object.values(row).some(
              (val) => String(val ?? "").trim() !== ""
            )
          );

          const jsonData = cleanedRows.map((row, index) => {
            // 1) Required fields (ensure non-empty after trimming)
            userCsvRequiredFiled.forEach((requiredField) => {
              const v = row[requiredField];
              if (v === undefined || String(v).trim() === "") {
                throw new Error(
                  `Missing or empty value for required field "${requiredField}" in row ${
                    index + 1
                  }`
                );
              }
            });

            // 2) Date fields: accept only valid strings (keep as-is if valid)
            ["Birth Date", "Joining Date"].forEach((dateKey) => {
              const val = row[dateKey];
              if (val && isValidDateString(val)) {
                row[dateKey] = String(val).trim(); // keep the same format
              }
            });

            // 3) Aadhaar: coerce to string (handles Excel "8.35878E+11") then validate
            if (row["AadharCard Number"] !== undefined) {
              const aadhaar = String(
                row["AadharCard Number"]
              ).replace(/\s+/g, "");
              if (!aadharRegex.test(aadhaar)) {
                throw new Error(
                  `Invalid Aadhar number in row ${index + 1}: ${
                    row["AadharCard Number"]
                  }`
                );
              }
              row["AadharCard Number"] = aadhaar; // normalized
            }

            // 4) Phone: coerce to string then validate
            if (row["Phone Number"] !== undefined) {
              const phone = String(row["Phone Number"]).replace(
                /\s+/g,
                ""
              );
              if (!phoneRegex.test(phone)) {
                throw new Error(
                  `Invalid Phone number in row ${index + 1}: ${
                    row["Phone Number"]
                  }`
                );
              }
              row["Phone Number"] = phone; // normalized
            }

            return row;
          });

          setExcelOrCsvData(jsonData);
        } catch (error) {
          return toastHelper("error", error.message);
        }
      }
    });
  };

  useEffect(() => {
    const ruleArray = [];
    if (rules !== null) {
      rules.activeNow.map((singleRule) => {
        ruleArray.push({
          _id: singleRule._id,
          shiftIn: singleRule.shiftIn,
          shiftOut: singleRule.shiftOut,
          shiftCode: singleRule.shiftCode,
          shiftType: singleRule.shiftType,
          locationName: singleRule.locationName,
          locationType: singleRule.locationType
        });
      });
      setAllRules(ruleArray);
    } else {
      setAllRules([]);
    }
  }, [rules]);

  const onLocationChange = (e) => {
    const { value } = e.target;
    setSelectLocationId(value);
    dispatch(ruleActions.getAllRulesByLocationId(value, loginType));
  };

  const topInput = (
    <form onSubmit={onSubmit}>
      <div className="row mb-2">
        <div className="col-md-2 mt-2 col-xl-2 col-lg-2">
          <SelectInput
            required={true}
            name="isUpdate"
            textWhite={false}
            isLabeled={false}
            value={isUpdate}
            label="Select Type"
            onChange={(e) => setIsUpdate(e.target.value)}
          >
            <option value=""> Select Type</option>
            <option value="NO">REGISTER USERS</option>
            <option value="YES">UPDATE USERS</option>
          </SelectInput>
        </div>
        <div className="col-md-2 mt-2 col-xl-2 col-lg-2">
          <SelectInput
            required={true}
            name="zoneId"
            textWhite={false}
            isLabeled={false}
            value={zoneId}
            label="Select Zone"
            onChange={(e) => setZoneId(e.target.value)}
          >
            <option value=""> Select Zone</option>
            {allZoneData.map((zoneValue, index) => (
              <option value={zoneValue?._id} key={index}>
                {zoneValue?.zoneName}
              </option>
            ))}
          </SelectInput>
        </div>
        <div className="col-md-2 mt-2 col-xl-2 col-lg-2">
          <SelectInput
            required={true}
            name="location"
            textWhite={false}
            isLabeled={false}
            value={locationId}
            label="Select Location"
            onChange={onLocationChange}
          >
            <option value=""> Select Location</option>
            {isSuperAdmin(currentUser)
              ? renderLocationFunction(allLocations)
              : renderAccessLocation2(
                  locationRender(currentUser, false)
                )}
          </SelectInput>
        </div>
        <div className="col-md-3 mt-2 col-xl-3 col-lg-3">
          <SelectInput
            required={true}
            textWhite={false}
            isLabeled={false}
            label="Select Rule"
            name="ruleId"
            value={ruleId}
            onChange={(e) => setRuleId(e.target.value)}
          >
            <option value=""> Select Rule</option>
            {allRules.map((rule, index) => (
              <option value={rule._id} key={index}>
                {rule.shiftCode +
                  " / " +
                  rule.shiftIn +
                  " - " +
                  rule.shiftOut}
              </option>
            ))}
          </SelectInput>
        </div>
        <div className="col-md-3 mt-2 col-xl-3 col-l-3">
          <TextInput
            type="file"
            file={true}
            accept=".csv"
            required={true}
            textWhite={false}
            htmlFor="excelFile"
            onChange={(e) => {
              const csvFile = e.target.files[0];
              convertingCsvIntoJson(csvFile);
              setExcelFile(csvFile);
            }}
            label="Add CSV File"
          />
        </div>

        <div className="form-group text-center col-sm-2 mt-3 col-xl-2 col-lg-2">
          {authLoading ? (
            <SpinnerButton />
          ) : (
            <Button
              type="submit"
              title="Submit"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn text-white btn-block btn-dark"
            />
          )}
        </div>
      </div>
    </form>
  );

  const renderExcel = (
    <div className="row mt-3">
      <WorkerTable data={ExcelOrCsvData} />
    </div>
  );

  return (
    <Starter
      topBarTitle="Register CSV"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Registration Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Registration</a>
          </li>
          <li className="breadcrumb-item active">Register CSV</li>
        </Fragment>
      }
    >
      <Card>
        <div className="row mb-2">
          <div className="col-sm-4">
            <Link
              to="/hr/user/all-users"
              className="btn mb-2 text-white btn-dark"
            >
              <i className="mdi mdi-plus-circle mr-2"></i> All Users
            </Link>
          </div>
          <div className="col-sm-8">
            <div className="text-sm-right"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <Strong
              title="All inputs are compulsory*"
              className="text-danger float-right"
            />
            <HeaderTag
              type="h4"
              isClassName={false}
              title="Add Employee CSV List"
            />
            <P title="Fill the form below to Register Multiple / Single Employee Data" />
            <HeaderTag
              type="h4"
              isClassName={true}
              className="text-danger"
              title="[ SYSTEM ONLY ACCEPT CSV FILE and only 30 Data at a time, want to register more data at once please contact to developers]"
            />
          </div>
        </div>
        {topInput}
        {authRegisterUserError &&
          authRegisterUserError.map((data, i) => (
            <ErrorRender errors={data} key={i} />
          ))}
        {response && <ResponseRender response={response} />}
      </Card>

      <div className="row mb-3">
        <div className="col-lg-12">
          <button>
            <a href={sampleExcelFile} download>
              Download Sample Excel File To Register New Users
            </a>
          </button>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-lg-12">
          <Card>
            <Image src={register_user} fluid />
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <Card>{renderExcel}</Card>
        </div>
      </div>
    </Starter>
  );
};

export default ExcelRegister;
